import type { Router } from 'vue-router'

import nprogress from 'nprogress'

import { clearOnboardingPath, recordOnboardingPath } from '@/utils/onboarding-history'

import { authGuard } from './auth-guard'

/**
 * global router guard
 * now only used for progress bar
 */
function setupCommonGuard(router: Router) {
  router.beforeEach(() => {
    nprogress.start()
    return true
  })
  router.afterEach((to) => {
    nprogress.done()
    if (to.path.startsWith('/onboarding')) {
      recordOnboardingPath(to.fullPath)
    }
    else {
      clearOnboardingPath()
    }
    return true
  })
}

export function createRouterGuard(router: Router) {
  setupCommonGuard(router)
  authGuard(router)
}
